import React, { useState } from "react";
import { Modal, Divider, message } from "antd";
import moment from "moment";

import { useAggregateReport } from "./useAggregateReport";
import ReportCharts from "./ReportCharts";
import OrdersByUserTable from "./OrdersByUserTable";
import OrdersByCompanyTable from "./OrdersByCompanyTable";
import axiosInstance from "../../config/axios/axios.config";
import ReportHeader from "./ReportHeader";
import ReportTitle from "./ReportTitle";
import AggregatedTable from "./AggregatedTable";
import {
  getAggreatedSourceData,
  getPieChart,
  getAggregatedByCompanyData,
  getOrderByUserData,
} from "../../helpers/adminReport";

const EnhancedOverallOrdersCardWithFilters = () => {
  const lastMonthStart = moment().subtract(1, "months").startOf("month");
  const lastMonthEnd = moment();

  const [timeFrame, setTimeFrame] = useState([lastMonthStart, lastMonthEnd]);
  const [sourceType, setSourceType] = useState("all");
  const [company, setCompany] = useState("all");
  const [isRefreshing, setIsRefreshing] = useState(false);
  const { data, isLoading, isError } = useAggregateReport({
    start_date: timeFrame[0],
    end_date: timeFrame[1],
  });

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (isError) {
    return <div>Error...</div>;
  }

  let filteredData = [...data];
  if (sourceType !== "all" && company !== "all") {
    filteredData = filteredData?.filter(
      (item) => item.source === sourceType && item.company === company
    );
  } else if (sourceType !== "all") {
    filteredData = filteredData?.filter((item) => item.source === sourceType);
  } else if (company !== "all") {
    filteredData = filteredData?.filter((item) => item.company === company);
  }
  let orderByUserData = getOrderByUserData(filteredData);
  let pieData = getPieChart(filteredData);
  let aggregatedArrayData = getAggreatedSourceData(filteredData);

  const sourceNames = [...new Set(data.map((item) => item.source))];
  const uniqueCompanies = Array.from(new Set(data.map((item) => item.company)));

  const handleDateRangeChange = (dates) => {
    setTimeFrame(dates);
    setSourceType("all");
    setCompany("all");
  };

  const handleRefresh = async () => {
    try {
      setIsRefreshing(true);
      await axiosInstance.get("/reports/aggregated-report/");
      setIsRefreshing(false);
      let today = moment();
      let newRange = [timeFrame[0], today];
      setTimeFrame(newRange);
      message.success("Data refreshed successfully");
    } catch (error) {
      setIsRefreshing(false);
    }
  };

  const confirmAndRefresh = () => {
    Modal.confirm({
      title: "Confirm",
      content: "Are you sure you want to refresh?",
      onOk() {
        handleRefresh();
      },
    });
  };

  return (
    <>
      <ReportTitle
        confirmAndRefresh={confirmAndRefresh}
        isRefreshing={isRefreshing}
      />
      <Divider />
      <ReportHeader
        lastMonthStart={lastMonthStart}
        lastMonthEnd={lastMonthEnd}
        timeFrame={timeFrame}
        handleDateRangeChange={handleDateRangeChange}
        setSourceType={setSourceType}
        setCompany={setCompany}
        sourceNames={sourceNames}
        uniqueCompanies={uniqueCompanies}
      />
      <Divider />
      <h3 style={{ marginBottom: 16, fontWeight: "600" }}>Overall Orders</h3>
      <AggregatedTable aggregatedArrayData={aggregatedArrayData} />

      <Divider />
      <h3 style={{ marginBottom: 16, fontWeight: "600" }}>Orders By Source</h3>
      <ReportCharts data={aggregatedArrayData} pieData={pieData} />

      <Divider />
      <h3 style={{ marginBottom: 16, fontWeight: "600" }}>Orders By Company</h3>
      <OrdersByCompanyTable data={getAggregatedByCompanyData(filteredData)} />

      <Divider />
      <h3 style={{ marginBottom: 16, fontWeight: "600" }}>Orders By User</h3>
      <OrdersByUserTable data={orderByUserData} />
    </>
  );
};

export default EnhancedOverallOrdersCardWithFilters;
